import React from 'react'
import COLORS, { transparency } from '../styles/colors'
import PlusSign from 'assets/svgs/PlusSign'
import { createUseStyles } from 'react-jss'
import Close from 'assets/svgs/Close'

interface Props {
  photo?: any
  big?: boolean
  onAddPhoto?: () => void
  onRemovePhoto?: () => void
  onUpdatePhoto?: () => void
}

const PhotoSelector = (props: Props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.container}>
      {!!props.photo && (
        <span className={classes.closeContainer} onClick={props.onRemovePhoto}>
          <Close color={COLORS.greyscale.white} style={{ width: 16, height: 16 }} />
        </span>
      )}
      <button
        className={classes.button}
        onClick={!!props.photo ? props.onUpdatePhoto : props.onAddPhoto}
      >
        <div className={classes.overlay} />
        {!!props.photo ? (
          <img src={props.photo} alt='Propriedade' className={classes.photo} />
        ) : (
          <div className={classes.plusContainer}>
            <PlusSign />
          </div>
        )}
      </button>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    width: '100%',
  },
  overlay: (props: Props) => ({
    content: ' ',
    position: 'absolute',
    transition: 'opacity .4s ease',
    width: '100%',
    opacity: 0,
    height: '100%',
    backgroundColor: props.photo
      ? COLORS.greyscale.overlay
      : transparency(COLORS.greyscale.light, 0.5),
    zIndex: 9,
  }),
  button: (props: Props) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${COLORS.brand.primary}`,
    borderRadius: 6,
    width: '100%',
    height: props.big ? 250 : 150,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'background-color .4s ease',
    padding: 0,
    overflow: 'hidden',
    position: 'relative',

    '&:hover': {
      '& div[class^="overlay-"]': {
        opacity: 1,
      },
    },
  }),
  photo: (props: Props) => ({
    backgroundSize: 'contain',
    width: '100%',
    height: props.big ? 250 : 150,
    borderRadius: 6,
  }),
  plusContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 99,
  },
  closeContainer: {
    position: 'absolute',
    right: 16,
    top: 16,
    zIndex: 99,
    cursor: 'pointer',
  },
})

export default PhotoSelector
